import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {ExpensePostOfficeState, ReceiptPostOfficeState} from "@/interfaces/state";
import store from "@/store";
import {IdMapper} from "@/interfaces/state/base";
import {DebtPostOffice} from "@/interfaces/entity";
import {PaginationMeta} from "@/interfaces/common";
import {ExpensePostOfficeParams} from "@/modules/receiptsexpenses/expensepostoffice/params";
import { union, difference } from 'lodash';
import {expensePostOffice, listDebtPostOffice} from "@/modules/receiptsexpenses/expensepostoffice/services";
import {ExpensePickingListStore} from "@/modules/receiptsexpenses/expensepickinglist/store";

@Module({ dynamic: true, name: "expensePostOfficeStore", store })
class ExpensePostOfficeModule extends VuexModule implements ExpensePostOfficeState {
    data: IdMapper<DebtPostOffice> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: ExpensePostOfficeParams = new ExpensePostOfficeParams();

    @Mutation
    private MAP_CREDIT_POST_OFFICE(payload: any) {
        const idMapper: IdMapper<DebtPostOffice> = {};
        this.meta = payload.meta;
        this.ids = payload.datas?.map((debt: DebtPostOffice, index: number) => {
            idMapper[debt.id] = {...debt, stt: index + 1};
            return debt.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private SET_CREDIT_POST_OFFICE(payload: any) {
        this.ids = union(this.ids, [payload.id]);
        this.data[payload.id] = payload;
    }

    @Mutation
    private UPDATE_PARAMS_CREDIT_POST_OFFICE(payload: any) {
        this.params = payload;
    }

    @Mutation
    private DELETE_CREDIT_POST_OFFICE_BY_IDS(payload: number[]) {
        this.ids = this.ids.filter((id: number) => !payload.includes(id));
        payload.forEach((id: number) => delete this.data[id]);
    }

    @Mutation
    private CLEAR_CREDIT_POST_OFFICE_STORE() {
        this.ids = [];
        this.data = {};
    }

    @Action({ rawError: true })
    public async listCreditPostOffice(params: any) {
        const { data } = await listDebtPostOffice(params);
        this.MAP_CREDIT_POST_OFFICE(data);
        return data.datas;
    }

    @Action({ rawError: true })
    public async expensePostOffice(dataReq: any) {
        const { data } = await expensePostOffice(dataReq);
        ExpensePickingListStore.setExpensePickingList(data.data);
        return data.data;
    }

    @Action({ rawError: true })
    public updateParamsCreditPostOffice(payload: any) {
        this.UPDATE_PARAMS_CREDIT_POST_OFFICE(payload);
    }

    @Action({ rawError: true })
    public clearCreditPostOfficeStore() {
        this.CLEAR_CREDIT_POST_OFFICE_STORE();
    }

    @Action({ rawError: true })
    public deleteCreditPostOfficeByIds(payload: any) {
        this.DELETE_CREDIT_POST_OFFICE_BY_IDS(payload);
    }
}

export const ExpensePostOfficeStore = getModule(ExpensePostOfficeModule);